<template lang="html">
  <div class="body">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="finishedText"
      :immediate-check="false"
      @load="loadMore"
    >
      <van-cell
        v-for="giftCard in giftCards" :key="giftCard.id"
        @click="giftCardDetail(giftCard.id)"
      >
        <van-skeleton
          avatar
          avatar-shape="square"
          avatar-size="50"
          :row="3"
          :loading="skeletonLoading"
        >
          <!-- <GiftCardDetail
            :giftCardData="giftCard"
          /> -->
          <GiftCardDetail
            :list-mode="true"
            :gift-card-data="giftCard"
          />
          <van-row>
            <van-col offset="2" span="22">
              <EpisodeCard
                :click-disabled="true"
                :compact="true"
                :showDescription="false"
                :showRating="false"
                :showPubtime="false"
                :episodeId="giftCard.object_id"
              />
            </van-col>
          </van-row>
        </van-skeleton>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import Vue from 'vue'
import { List } from 'vant'
import { Cell, CellGroup } from 'vant'
import { Skeleton } from 'vant'
import GiftCardDetail from './gift-card-detail.vue'
import EpisodeCard from './episode-card.vue'
Vue.use(List)
Vue.use(Cell).use(CellGroup)
Vue.use(Skeleton)
export default {
  name: 'gift-card-list',
  components: {
    GiftCardDetail,
    EpisodeCard
  },
  data () {
    return {
      skeletonLoading: false,
      loading: false,
      finished: false,
      finishedText: '没有更多了',
      giftCards: [],
      next: '',
    }
  },
  props: {
    slug: {
      type: String,
      default: ''
    },
    buyer: {
      type: String,
      default: 'me'
    }
  },
  watch: {
    slug (newVal, oldVal) {
      window.console.log("watch slug")
      window.console.log(newVal)
      window.console.log(oldVal)
      if (newVal && newVal != oldVal) {
        this.getGiftCards()
      }
    }
  },
  methods: {
    loadData () {
      this.getGiftCards()
    },
    getGiftCards () {
      let that = this
      let params = { slug: that.slug, active: true }
      window.console.log("开始获得GiftCards...")
      that.$api.giftcard.list(params).then(res => {
        window.console.log("获得GiftCards")
        window.console.log(res.data)
        that.next = res.data.next
        that.loading = false
        if (res.data.next == null) {
          that.finished = true
        }
        if (that.limit > 0) {
          that.giftCards = res.data.results.slice(0, that.limit)
        } else {
          that.giftCards = res.data.results
        }
        return
      })
    },
    loadMore () {
      window.console.log("loadMore...")
      let that = this
      if (that.next) {
        that.loading = true
        let url = that.next.split('/api/')[1] // 截掉前面的域名和 /api/ 部分
        that.$api.normal.load(url).then(res => {
          that.giftCards = that.giftCards.concat(res.data.results)
          that.next = res.data.next
          that.loading = false
          if (that.next == null) {
            that.finished = true
          }
        })
      } else {
        if (that.next === null) {
          that.finished = true
        }
      }
    },
    giftCardDetail (giftCardId) {
      this.$router.replace({
        name: 'GiftCardDetailPage',
        params: {
          giftcardId: giftCardId
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
